export function unsetFocus() {
  try {
    ;(document.activeElement as any)?.blur()
  } catch {}
}
